import React from 'react'
import AvailableInterviews from './AvailableInterviews'
import CompletedInterviews from './CompletedInterviews'
import { ReactComponent as SearchLogo } from "../../../assets/icons/SearchLogo.svg";
import { ReactComponent as FilterLogo } from "../../../assets/icons/FilterLogo.svg";

const StudentInterview = () => {
  return (
    <>
     {/* <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="flex items-center space-x-4">
                    <div className="flex-1 relative">
                        <SearchLogo />
                        <input
                            type="text"
                            placeholder="Search interviews..."
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:border-transparent"
                            value=""
                            readOnly
                        />
                    </div>
                    <div className="flex items-center space-x-2">
                        <FilterLogo />
                        <select className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:border-transparent">
                            <option value="all">All Categories </option>
                            <option value="marketing">Marketing</option>
                            <option value="sales">Sales</option>
                        </select>
                    </div>
    
                </div>
        </div> */}
    <AvailableInterviews/>
    <CompletedInterviews/>
    </>
  )
}

export default StudentInterview
